import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import BusinessSection from '../components/BusinessSection';
import TechSection from '../components/TechSection';
import CasesSection from '../components/CasesSection';
import PhilosophySection from '../components/PhilosophySection';
import VisionSection from '../components/VisionSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

declare global {
  interface Window {
    lucide: any;
  }
}

const EnHomePage: React.FC = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== 'en-US') {
      i18n.changeLanguage('en-US');
    }
    if (window.lucide?.createIcons) {
      window.lucide.createIcons();
    }
    const timer = setTimeout(() => {
      if (window.lucide?.createIcons) window.lucide.createIcons();
    }, 200);
    return () => clearTimeout(timer);
  }, [i18n]);

  return (
    <div className="en bg-dark-950 text-dark-200 antialiased overflow-x-hidden">
      <Navbar lang="en" />
      <main>
        <HeroSection />
        <AboutSection />
        <BusinessSection />
        <TechSection />
        <CasesSection lang="en" />
        <PhilosophySection />
        <VisionSection />
        <ContactSection />
      </main>
      <Footer lang="en" />
    </div>
  );
};

export default EnHomePage;
